export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/value.js
// module id = 2332
// module chunks = 67